import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CButton from '@/components/CButton'
import CSelect from '@/components/CForm/CSelect'
import CRadio from '@/components/CForm/CRadio'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData, tableData1, tableData2, tableData3} from './data'
import './index.scss'
import { getrankingHandler } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {Pagination,Spin} from "antd";


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.getListData();
  }


  state = {
    dataSource1: [],
    dataSource2: [],
    dataSource3: [],
    dataSourceAll1:[],
    dataSourceAll2:[],
    dataSourceAll3:[],
    loading: true,
    annual: '',
    levelid: '',
    ownerlist:[],
    options:[
      {
        "name": "全部",
        "id": '',
        "value": "",
      },
      {
        "name": "一级",
        "id": "1410",
        "value": "1410",
      },
      {
        "name": "二级",
        "id": "1411",
        "value": "1411",
      },
      {
        "name": "三级",
        "id": "1412",
        "value": "1412",
      }
    ],
    page1: {
      total: 0,
      page: 1,
      pageSize: 10
    },
    page2: {
      total: 0,
      page: 1,
      pageSize: 10
    },
    page3: {
      total: 0,
      page: 1,
      pageSize: 10
    },
  };

  onChange(name,data){
    this.setState({
      [name]:data
    })
  }
  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    const params = {
      annual:this.state.annual,
      levelid:this.state.levelid
    }
    getrankingHandler(params).then(res=>{
      console.log(res);
      if (res.statecode === 0) {
        if (res.records[0]){
          let one = JSON.parse(JSON.stringify( res.records[0].datalist))
          // var  one1 = one.splice((this.state.page1.page-1)*this.state.page1.pageSize,this.state.page1.page*this.state.page1.pageSize + 1)
          var r1 = [
            {
              title:res.records[0].title,
              datalist:one
            }
          ]
          this.setState({
            dataSource1: r1,
            dataSourceAll1:res.records[0],
            page1:{...this.state.page1,total:res.records[0].datalist.length},
          });
        }else {
          this.setState({
            dataSource1: [],
            dataSourceAll1:[],
            page1:{...this.state.page3,total:0}
          });
        }
        if ( res.records[1]){
          let two = JSON.parse(JSON.stringify( res.records[1].datalist))
          // var two2 = two.splice((this.state.page2.page-1)*this.state.page2.pageSize,this.state.page2.page*this.state.page2.pageSize + 1)
          var r2 = [
            {
              title:res.records[1].title,
              datalist:two
            }
          ]
          this.setState({
            dataSource2: r2,
            dataSourceAll2:res.records[1],
            page2:{...this.state.page2,total:res.records[1].datalist.length},
          });
        } else {
          this.setState({
            dataSource2: [],
            dataSourceAll2:[],
            page2:{...this.state.page3,total:0}
          });
        }
        if ( res.records[2]) {
          let three = JSON.parse(JSON.stringify(res.records[2].datalist))
          // var three3 = three.splice((this.state.page3.page - 1) * this.state.page3.pageSize, this.state.page3.page * this.state.page3.pageSize + 1)
          var r3 = [
            {
              title:res.records[2].title,
              datalist:three
            }
          ]
          this.setState({
            dataSource3: r3,
            dataSourceAll3:res.records[2],
            page3:{...this.state.page3,total:res.records[2].datalist.length}
          });
        } else {
          this.setState({
            dataSource3: [],
            dataSourceAll3:[],
            page3:{...this.state.page3,total:0}
          });
        }
        this.setState({
          loading:false,
        });
      }
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  onTableChange1(data){
    this.setState({
      page1:{...this.state.page1,page:data}
    },()=>{
      let d = JSON.parse(JSON.stringify(this.state.dataSourceAll1))
      var bIndex = (parseInt(this.state.page1.pageSize) * (parseInt(this.state.page1.page) - 1))+1;
      var eIndex = parseInt(bIndex) + (parseInt(this.state.page1.pageSize));
      var newDataList = [];
      for(var i = bIndex;i < eIndex;i++){
        if (d.datalist[i]) {
          newDataList.push(d.datalist[i]);
        }
      }
      let r = [
        {
          title:this.state.dataSourceAll1.title,
          datalist:newDataList
        }
      ]
      this.setState({
        dataSource1:r
      })
    })
  }
  onShowSizeChange1(pageSize){
    this.setState({
      page1:{...this.state.page1,pageSize:pageSize}
    },()=>{
      let d = JSON.parse(JSON.stringify(this.state.dataSourceAll1))
      var bIndex = (parseInt(this.state.page1.pageSize) * (parseInt(this.state.page1.page) - 1))+1;
      var eIndex = parseInt(bIndex) + (parseInt(this.state.page1.pageSize));
      var newDataList = [];
      for(var i = bIndex;i < eIndex;i++){
        if (d.datalist[i]) {
          newDataList.push(d.datalist[i]);
        }
      }
      let r = [
        {
          title:this.state.dataSourceAll1.title,
          datalist:newDataList
        }
      ]
      this.setState({
        dataSource1:r
      })
    })
  }

  onTableChange2(data){
    this.setState({
      page2:{...this.state.page2,page:data}
    },()=>{
      let d = JSON.parse(JSON.stringify(this.state.dataSourceAll2))
      var bIndex = (parseInt(this.state.page2.pageSize) * (parseInt(this.state.page2.page) - 1))+1;
      var eIndex = parseInt(bIndex) + (parseInt(this.state.page2.pageSize));
      var newDataList = [];
      for(var i = bIndex;i < eIndex;i++){
        if (d.datalist[i]) {
          newDataList.push(d.datalist[i]);
        }
      }
      let r = [
        {
          title:this.state.dataSourceAll2.title,
          datalist:newDataList
        }
      ]
      this.setState({
        dataSource2:r
      })
    })
  }
  onShowSizeChange2(pageSize){
    this.setState({
      page2:{...this.state.page2,pageSize:pageSize}
    },()=>{
      let d = JSON.parse(JSON.stringify(this.state.dataSourceAll2))
      var bIndex = (parseInt(this.state.page2.pageSize) * (parseInt(this.state.page2.page) - 1))+1;
      var eIndex = parseInt(bIndex) + (parseInt(this.state.page2.pageSize));
      var newDataList = [];
      for(var i = bIndex;i < eIndex;i++){
        if (d.datalist[i]) {
          newDataList.push(d.datalist[i]);
        }
      }
      let r = [
        {
          title:this.state.dataSourceAll2.title,
          datalist:newDataList
        }
      ]
      this.setState({
        dataSource2:r
      })
    })
  }

  onTableChange3(data){
    this.setState({
      page3:{...this.state.page3,page:data}
    },()=>{
      let d = JSON.parse(JSON.stringify(this.state.dataSourceAll3))
      var bIndex = (parseInt(this.state.page3.pageSize) * (parseInt(this.state.page3.page) - 1))+1;
      var eIndex = parseInt(bIndex) + (parseInt(this.state.page3.pageSize));
      var newDataList = [];
      for(var i = bIndex;i < eIndex;i++){
        if (d.datalist[i]) {
          newDataList.push(d.datalist[i]);
        }
      }
      let r = [
        {
          title:this.state.dataSourceAll3.title,
          datalist:newDataList
        }
      ]
      this.setState({
        dataSource3:r
      })
    })
  }
  onShowSizeChange3(pageSize){
    this.setState({
      page3:{...this.state.page3,pageSize:pageSize}
    },()=>{
      let d = JSON.parse(JSON.stringify(this.state.dataSourceAll3))
      var bIndex = (parseInt(this.state.page3.pageSize) * (parseInt(this.state.page3.page) - 1))+1;
      var eIndex = parseInt(bIndex) + (parseInt(this.state.page3.pageSize));
      var newDataList = [];
      for(var i = bIndex;i < eIndex;i++){
        if (d.datalist[i]) {
          newDataList.push(d.datalist[i]);
        }
      }
      let r = [
        {
          title:this.state.dataSourceAll3.title,
          datalist:newDataList
        }
      ]
      this.setState({
        dataSource3:r
      })
    })
  }
  componentWillMount(){

  }

  componentDidMount(){
    const yearrange = JSON.parse(localStorage.getItem('userInfo'))[0].sysidlist
    const arr = []
    yearrange.forEach(item=>{
      let obj = {}
      obj.name = item
      obj.id = item
      obj.value = item
      arr.push(obj)
    })
    this.setState({
      ownerlist:arr,
      annual:arr[0].id,
    },()=>{
      this.getListData();
    })
  }
  render(){
    return (
        <Spin spinning={this.state.loading}>
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='filter-left' style={{width: '100%',display:'flex',flexWrap:'wrap',alignItems:'center',marginBottom:'20px'}}>
              <div style={{width:'250px',marginTop:'-10px'}}>
                <label htmlFor="" >
                  评估年度：</label>
                <CSelect
                    value={this.state.annual}
                    options={this.state.ownerlist}
                    placeholder='请选择评估年度'
                    onChange={(e)=>{this.onChange('annual',e)}}
                    style={{width: '100px'}}
                />
              </div>
              <div style={{width:'400px'}}>
                <label htmlFor="" >
                  质量等级：</label>
                <CRadio
                    value={this.state.levelid}
                    options={this.state.options}
                    onChange={(e)=>{this.onChange('levelid',e)}}
                />
              </div>
              <CButton type='primary' onClick={this.getListData}>查询</CButton>
            </div>
          </div>
          {this.state.dataSource1.map((item,index)=>{
                return(
                    <div>
                        {index === 0?
                            <h2>{item.title}</h2>:
                            <h2 style={{marginTop:'50px'}}>{item.title}</h2>
                        }
                        {
                            item.datalist.map((item,index1)=>{
                                return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                                    {
                                        item.map(item2=>{
                                            return (
                                                <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                                            )
                                        })
                                    }
                                </div>)
                            })
                        }
                    </div>
                )
            })}
          {/*{this.state.dataSourceAll1.datalist && this.state.dataSourceAll1.datalist.length > 0 &&*/}
          {/*<Pagination*/}
          {/*    style={{margin:'20px 0'}}*/}
          {/*    total={this.state.dataSourceAll1.datalist.length}*/}
          {/*    current={this.state.page1.page}*/}
          {/*    showSizeChanger*/}
          {/*    showQuickJumper*/}
          {/*    onChange={(pageNumber)=>{this.onTableChange1(pageNumber)}}*/}
          {/*    onShowSizeChange={(page,pageSize)=>{this.onShowSizeChange1(pageSize)}}*/}
          {/*    // showTotal={(total) => `Total ${total} items`}*/}
          {/*/>*/}
          {/*}*/}
          {this.state.dataSource2.map((item,index)=>{
            return(
                <div>
                  {index === 0?
                      <h2>{item.title}</h2>:
                      <h2 style={{marginTop:'50px'}}>{item.title}</h2>
                  }
                  {
                    item.datalist.map((item,index1)=>{
                      return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                        {
                          item.map(item2=>{
                            return (
                                <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                            )
                          })
                        }
                      </div>)
                    })
                  }
                </div>
            )
          })}
          {/*{this.state.dataSourceAll2.datalist && this.state.dataSourceAll2.datalist.length > 0 &&*/}
          {/*    <Pagination*/}
          {/*        style={{margin: '20px 0'}}*/}
          {/*        total={this.state.dataSourceAll2.datalist.length}*/}
          {/*        current={this.state.page2.page}*/}
          {/*        showSizeChanger*/}
          {/*        showQuickJumper*/}
          {/*        onChange={(pageNumber) => {*/}
          {/*          this.onTableChange2(pageNumber)*/}
          {/*        }}*/}
          {/*        onShowSizeChange={(page, pageSize) => {*/}
          {/*          this.onShowSizeChange2(pageSize)*/}
          {/*        }}*/}
          {/*        // showTotal={(total) => `Total ${total} items`}*/}
          {/*    />*/}
          {/*}*/}
          {this.state.dataSource3.map((item,index)=>{
            return(
                <div>
                  {index === 0?
                      <h2>{item.title}</h2>:
                      <h2 style={{marginTop:'50px'}}>{item.title}</h2>
                  }
                  {
                    item.datalist.map((item,index1)=>{
                      return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                        {
                          item.map(item2=>{
                            return (
                                <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                            )
                          })
                        }
                      </div>)
                    })
                  }
                </div>
            )
          })}
          {/*{this.state.dataSourceAll3.datalist && this.state.dataSourceAll3.datalist.length > 0 &&*/}
          {/*    <Pagination*/}
          {/*        style={{margin: '20px 0'}}*/}
          {/*        total={this.state.dataSourceAll3.datalist.length}*/}
          {/*        current={this.state.page3.page}*/}
          {/*        showSizeChanger*/}
          {/*        showQuickJumper*/}
          {/*        onChange={(pageNumber) => {*/}
          {/*          this.onTableChange3(pageNumber)*/}
          {/*        }}*/}
          {/*        onShowSizeChange={(page, pageSize) => {*/}
          {/*          this.onShowSizeChange3(pageSize)*/}
          {/*        }}*/}
          {/*        // showTotal={(total) => `Total ${total} items`}*/}
          {/*    />*/}
          {/*}*/}
        </div>
        </Spin>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
